export const GROUP_NAME = 'loader'

export enum Sizes {
  // Extra Extra Small.
  XXS = 'xxs',

  // Extra Small.
  XS = 'xs',

  // Small.
  S = 's',

  // Medium.
  M = 'm',

  // Large.
  L = 'l',

  // Extra Large.
  XL = 'xl',
}

export const DEFAULT_SIZE = Sizes.M

export const DURATION = '3.5s'
